import { render, staticRenderFns } from "./Coupon2.vue?vue&type=template&id=ec4d174c&scoped=true&"
import script from "./Coupon2.vue?vue&type=script&lang=js&"
export * from "./Coupon2.vue?vue&type=script&lang=js&"
import style0 from "./Coupon2.vue?vue&type=style&index=0&id=ec4d174c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4d174c",
  null
  
)

export default component.exports